// Shared positioning for natural-text-editing DOM overlays (TextAsset and HtmlAsset). Overlays are
// injected into an editor-provided container that the editor transforms (zoom/pan), so they are
// positioned as a percentage of the reference resolution rather than in screen pixels.

export interface OverlayBounds {
    x: number;
    y: number;
    width: number;
    height: number;
}

export interface Resolution {
    width: number;
    height: number;
}

/** Position an absolutely-positioned overlay as a percentage of the reference resolution. */
export function positionOverlayInReferenceResolution(
    element: HTMLElement,
    bounds: OverlayBounds,
    resolution: Resolution,
): void {
    element.style.left = `${(bounds.x / resolution.width) * 100}%`;
    element.style.top = `${(bounds.y / resolution.height) * 100}%`;
    element.style.width = `${(bounds.width / resolution.width) * 100}%`;
    element.style.height = `${(bounds.height / resolution.height) * 100}%`;
}

/** Screen pixels per reference pixel for the editing container — used to scale font sizes into on-screen units. */
export function domScaleForContainer(domContainer: HTMLElement, resolution: Resolution): number {
    return domContainer.getBoundingClientRect().width / resolution.width;
}
